import { Box, HStack, VStack, Text } from "@chakra-ui/react";

// Chakra's <Progress> só suporta um único valor — a "Composição do mês" do dashboard
// precisa de múltiplos segmentos lado a lado, por isso este componente próprio.
export default function SegmentedProgressBar({ segments, height = "10px", showLegend = true }) {
  const total = segments.reduce((acc, s) => acc + (s.value || 0), 0);

  return (
    <VStack align="stretch" spacing={3}>
      <HStack spacing="2px" height={height} borderRadius="full" overflow="hidden" bg="app-muted">
        {segments.map((s) => {
          const pct = total > 0 ? (s.value / total) * 100 : 0;
          if (pct <= 0) return null;
          // width via style inline (não prop do Chakra): valores dinâmicos gerariam uma
          // classe emotion nova por render — e inline style é testável diretamente.
          return <Box key={s.label} style={{ width: `${pct}%` }} height="100%" bg={s.colorToken} title={s.label} />;
        })}
      </HStack>
      {showLegend ? (
        <HStack spacing={4} flexWrap="wrap">
          {segments.map((s) => (
            <HStack key={s.label} spacing={1.5}>
              <Box boxSize="8px" borderRadius="full" bg={s.colorToken} />
              <Text fontSize="xs" color="app-muted-fg">
                {s.label}
              </Text>
            </HStack>
          ))}
        </HStack>
      ) : null}
    </VStack>
  );
}
